export default __webpack_public_path__ + "static/media/85_mobile.4dc1bcea.jpg";